import { useState } from "react";
import "./Navbar.css";
import logo from "./assets/logo.webp";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      
      {/* LOGO */}
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      {/* MENU */}
      <ul className={open ? "nav-links active" : "nav-links"}>
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      {/* MENU BUTTON */}
      <div className="menu-btn" onClick={() => setOpen(!open)}>
        ☰
      </div>

    </header>
  );
}